const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/sections/Finalize.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { ECheckinSectionProps } from '../../types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';
import textMap from './translations';
import { useIntl } from 'react-intl';
import mobileImage from './images/online_checkin_illustration_handy-1.svg';
import desktopImage from './images/online_checkin_illustration_desktop-1.svg';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const imageCSS = css`
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    max-height: 200px;
    width: 100%;
`;

interface Props {
    title?: TextInput;
}

export const Finalize = forwardRef((props: Omit<ECheckinSectionProps, 'title'> & Props, ref: any) => {
    const { path } = props;
    const title = useText(props.title || textMap.finalizeTitle);
    const { formatMessage } = useIntl();

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <img src={`${smallScreen ? mobileImage : desktopImage}`} className={imageCSS} />
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: formatMessage(textMap.finalizeContent) }} />
        </ECheckinSection>
    );
});

Finalize.displayName = 'Finalize';

export default Finalize;
